export const getTotalContractPrice = (subSystems, isBooking = false) => {
  if (!subSystems || !Array.isArray(subSystems)) {
    return 0
  }
  const totalPrice = subSystems.reduce((systemPrice, subSystem) => {
    const rowSource = isBooking ? subSystem.bookingContractPrices : subSystem.totalContractPrice?.newContractRows
    const subSystemTotal = rowSource.reduce((sum, row) => {
      return sum + row?.total || 0
    }, 0)

    return systemPrice + subSystemTotal
  }, 0)

  return totalPrice
}

export const getTotalPrice = (newContractRows) => {
  if (!newContractRows || !Array.isArray(newContractRows)) {
    return 0
  }
  return newContractRows.reduce((sum, row) => {
    return sum + row?.total || 0
  }, 0)
}
